import ApiService from "./ApiService";
import {
	CriteriaClassificationsDeleteRequest,
	CriteriaClassificationsDeleteResponse,
	CriteriaClassificationsGetResponse,
	CriteriaClassificationsPostRequest,
	CriteriaClassificationsPostResponse,
	CriteriaClassificationsPutRequest,
	CriteriaClassificationsPutResponse,
} from "src/entities/CriteriaClassificationEntity";

export const criteriaClassificationQueryKeys = {
	classifications: (id: string) => ["criteria", id, "classifications"] as const,
};

export default class CriteriaClassificationService extends ApiService {
	public async getClassifications(criteriaId: number) {
		return await this.request.get<CriteriaClassificationsGetResponse>(`/api/v1/criteria/${criteriaId}/classifications`);
	}
	public async postClassifications(data: CriteriaClassificationsPostRequest) {
		return await this.request.post<CriteriaClassificationsPostResponse>(`/api/v1/criteria/classifications`, data);
	}
	public async putClassifications(data: CriteriaClassificationsPutRequest) {
		return await this.request.put<CriteriaClassificationsPutResponse>(`/api/v1/criteria/classifications`, data);
	}
	public async deleteClassifications(data: CriteriaClassificationsDeleteRequest) {
		return await this.request.post<CriteriaClassificationsDeleteResponse>(`/api/v1/criteria/classifications/delete`, data);
	}
}
